export default (table) => {
  let name = 'country_name';
  
  switch (table) {
    case 'editCompensation':
    case 'editOnetime':      
    /* Release 3.2 - 1.1 - Starts */
    case 'editBEA':
      /* Release 3.2 - 1.1 - Ends */
    case 'rejectRequests':
    case 'approveRequests':
      case 'editInternalHire':
      name = 'request.for.country_name';
      break;
    case 'myRequests':
    case 'approvedRequestHistory':
    case 'requestsHistory':
    case 'pendingRequests':
      name = 'for.country_name';
      break;
    default:
      break;
  }

  return { 
    name,
    label: "Country",
    tooltip_section: "Current",
    visible_in_tooltip: /* Release 3.2 - 1.1 - Starts */(column, data, account) =>    
    (data.request_type === "businessexcellenceaward" || (data.request && data.request.request_type === "businessexcellenceaward")) ? false : true,
    /* Release 3.2 - 1.1 - Ends */
  };
};